import React from 'react'
import 'url-search-params-polyfill'
import {
  Container,
  Grid
} from 'semantic-ui-react'
import {
  NotificationContainer,
  NotificationManager
} from 'react-notifications'
// Local
import { forgotPassword } from '../../action/user'
// import { AutoLoginParams } from '../../../types'
import ForgotPasswordForm from './forgotPasswordForm'
import { history } from '../../store'
import { PAGES } from '../../constant'

// const queryParamsToObject = (
//   queryParams: string
// ): AutoLoginParams => {
//   const params = new URLSearchParams(queryParams)
//   const result: Record<string, string> = {}
//   params.forEach((value, key) => {
//     result[key] = value
//   })
//   return result as AutoLoginParams
// }

function ForgotPassword(): JSX.Element {
  const handleForgotSubmit = (email: string) => {
    forgotPassword(email, () => {
      // Do this for both valid and !valid cases, to give away as little information as possible.
      // eslint-disable-next-line max-len
      const message = 'If we find an account associated with this email address, we\'ll email you instructions for resetting your password.'
      NotificationManager.success(message, 'Thank you!', 10 * 1000)
      // give a few seconds so the person can read the message, then jump to the login page
      setTimeout(() => history.push(PAGES.LOGIN), 12 * 1000)
    })
  }

  const renderForgotForm = () => (
    <Container>
      <NotificationContainer />
      <div className="ui stackable grid">
        <Grid.Row
          columns={ 3 }
          only="computer"
          id="c-forgot-password-row-computer"
        >
          <Grid.Column />
          <Grid.Column>
            <ForgotPasswordForm
              id="computer"
              onSubmit={ handleForgotSubmit }
              errorMessage=""
            />
          </Grid.Column>
          <Grid.Column />
        </Grid.Row>

        <Grid.Row
          columns={ 1 }
          only="mobile tablet"
          id="c-forgot-password-login-row-mobile"
        >
          <Grid.Column>
            <ForgotPasswordForm
              id="mobile"
              onSubmit={ handleForgotSubmit }
              errorMessage=""
            />
          </Grid.Column>
        </Grid.Row>
      </div>
    </Container>
  )

  return renderForgotForm()
}

export default ForgotPassword
